import http from "../http-common";

class UserService {
  getUsers(email) {
    return http.get('/api/user?name=' + email);
  }
  getUser(id) {
    return http.get('/api/user/' + id);
  }
  createUser(data) {
    return http.post('/api/user', data);
  }
  updateUser(id, data) {
    return http.put(`/api/user/${id}`, data);
  }
  updateToken(id, data) {
    return http.put(`/api/user/token/${id}`, data);
  }
  getUserBytoken(id) {
    return http.get('/api/user/getbytoken/' + id);
  }
  getMenuByRole(id) {
    return http.get('/api/user/getmenubyrole?role_id=' + id);
  }
  getMenusAll() {
    return http.get('/api/menus');
  }
  getRolesAll() {
    return http.get('/api/roles');
  }
  getMenubyRoleIDAll(id) {
    return http.get('/api/user/getmenuarray/' + id);
  }
  createRoleMenu(data) {
    return http.post('/api/role_menu', data);
  }
  createRole(data) {
    return http.post(`/api/roles`, data);
  }
  updateRole(id, data) {
    return http.put(`/api/roles/${id}`, data);
  }
  deleteRoleMenu(id) {
    return http.delete(`/api/role_menu/` + id);
  }
  deleteUser(id) {
    return http.delete(`/api/user/` + id);
  }
  deleteRole(id) {
    return http.delete(`/api/roles/` + id);
  }
}

export default new UserService();